import React, { useEffect, useRef, useState } from "react";
import { AiFillPrinter } from "react-icons/ai";
import { useLocation, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { useGetProServiceByIdQuery } from "../../features/api/proserviceApi";
import { getuser } from "../../components/CommonDateFormat";
import { API_BASE_URL } from "../../components/baseUrl";

function ProServiceJobReport() {
  const user = getuser();
  // useRef for report
  const componentRef = useRef();

  const { id } = useParams();
  // get service product by id
  const { data } = useGetProServiceByIdQuery(id, {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });

  const productInfo = data;

  // console.log(productInfo);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  }

  return (
    <div className="w-full max-w-[1280px] mx-auto px-6 md:px-auto h-[90vh] overflow-auto py-8">
      <ReactToPrint
        trigger={() => (
          <h1 className="cursor-pointer flex items-center absolute right-5 gap-x-1 text-red-500">
            <AiFillPrinter /> Print
          </h1>
        )}
        content={() => componentRef.current}
        pageStyle="@page { size: A4;  margin: 1cm; } @media print { body { -webkit-print-color-adjust: exact; } }"
      />

      <div ref={componentRef}>
        <div className="mt-[12mm]">
          <div className="flex flex-col  ">
            <div className="">
              <div className="flex items-start justify-between">
                <div className="w-[240px] text-justify">
                  <h1 className="font-bold">Johura Endomed Solution</h1>
                  <h2 className="font-bold text-sm">Service Center</h2>
                  <p className="font-bold text-xs">
                    15/A, Zigatola, Hafizullah Green Tower, Flat # C1 Dhanmondi,
                    Dhaka
                  </p>
                  <h1 className="font-bold text-xs">Phone: +88 01711 071102</h1>
                  <h1 className="font-bold text-xs">Phone: +88 01977 071102</h1>
                </div>
                <div className="flex flex-col gap-y-6">
                  <p className="bg-gray-200 p-1 mt-2 text-sm font-bold">
                    DELIVERY INFORMATION
                  </p>
                </div>
              </div>
            </div>
            <div className="">
              <div className="flex items-end justify-between">
                <div className="mt-4 text-sm">
                  <h1 className="font-bold">Client Information</h1>
                  <div className="flex gap-2">
                    <p className="font-semibold w-[80px]"> Client Name</p> :
                    <p className="font-bold">{productInfo?.client}</p>
                  </div>
                  <div className="flex gap-2">
                    <p className="font-semibold  w-[80px] "> Mobile</p> :
                    <p className="font-bold">{productInfo?.mobile}</p>
                  </div>
                  <div className="flex gap-2 ">
                    <p className="font-semibold  w-[80px] "> Address </p> :
                    <p className="font-bold">{productInfo?.address}</p>
                  </div>
                </div>
                <div className="">
                  <div className="flex gap-2">
                    <p className="font-bold  w-[102px]">Claim Date</p> :
                    <p> {formatDate(productInfo?.claim_date)}</p>
                  </div>
                  <div className="flex gap-2">
                    <p className="font-bold w-[102px]">Delivery Date</p> :
                    <p>
                      {" "}
                      {productInfo?.delivery_date
                        ? formatDate(productInfo?.delivery_date)
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-between gap-2 my-2 pb-1"></div>
            <div>
              <table className="min-w-full">
                <thead>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%]">
                      Job No.
                    </th>
                    <td className="border border-gray-400 pl-2">
                      {productInfo?.job_no}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Brand
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.brand}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Product
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.product}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Model
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.model}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Serial No.
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.slNo}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Complain Type
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.complain_type}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Warranty
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.war_type}
                    </td>
                  </tr>

                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Product Received Date
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.p_r_date
                        ? formatDate(productInfo?.p_r_date)
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Nature of Complain
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.nature_claim}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Accessories
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.accessories}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Previous Job No
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.prev_jobNo || "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Previous Job Date
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.prev_job_date
                        ? formatDate(productInfo?.prev_job_date)
                        : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Receive Location
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.p_rcve_loc}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Service Status
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.delivery_status}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Service Type
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.service_type}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Service Details
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.service_details
                        ?.split("\n")
                        .map((item, index) => (
                          <div key={index}>{item}</div>
                        ))}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 h-12 w-[50%] text-sm">
                      Remarks
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.remarks}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Job Done By
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.job_done_by}
                    </td>
                  </tr>
                </thead>
              </table>
            </div>
            <div className="flex justify-between mt-16">
              <p>
                <span className="font-bold text-sm border-t border-black">
                  Received by Client
                </span>
              </p>
              <p className="flex flex-col">
                <span className="font-bold text-sm">
                  Prepared By: {productInfo?.created_by}
                </span>
              </p>
              <p>
                <img
                  src={`${API_BASE_URL}/uploads/${user?.signature}`}
                  alt=""
                  className="w-12 h-12 mx-auto"
                />
                <span className="font-bold text-sm border-t border-black">
                  For Johura Endomed Solution
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProServiceJobReport;
